import { i18nTranslate } from 'src/utils'

function customGdprPopup() {
  // Create the consent container div
  const consentContainer = document.createElement('div')
  consentContainer.id = 'custom-consent-blackbar'

  // Add the style element dynamically
  const styleElement = document.createElement('style')
  styleElement.textContent = `
      .custom-consent-blackbar {
          border-top: 2px solid #123dba;
      }
      .custom-truste-banner {
          margin: 0 auto;
          background-color: rgb(224, 242, 255);
          opacity: 1;
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 9999;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
      }
      .custom-truste-messageColumn {
          font-family: Arial, sans-serif;
          font-size: 14px;
          color: #555;
          margin: 20px 0px;
          width: 80%;
          line-height: 18px;
      }
      .custom-close-btn {
          font-size: 20px;
          color: #555;
          background: none;
          border: none;
          cursor: pointer;
          padding: 5px 0px;
          position: absolute;
          top: 10px;
          right: 10px;
      }
      .custom-close-btn:hover {
          color: grey;
      }
      @media screen and (max-width: 1199px) {
          .custom-truste-messageColumn {
              float: none;
              margin: 20px;
              margin-right: 80px;
              width: auto !important;
          }
      }
  `
  document.head.appendChild(styleElement)

  // Create the consent banner content
  const bannerContent = document.createElement('div')
  bannerContent.id = 'custom-truste-consent-track'

  const bannerInner = document.createElement('div')
  bannerInner.id = 'custom-truste-consent-content'
  bannerInner.classList.add('custom-truste-banner')

  const messageColumn = document.createElement('div')
  messageColumn.id = 'custom-truste-consent-text'
  messageColumn.classList.add('custom-truste-messageColumn')
  messageColumn.textContent = i18nTranslate(
    'gdpr.custompopupmessage',
    'Because of the browser settings that you have selected, you may experience issues with some functionality of this website. If you experience issues, we recommend you switch to another browser, such as Google Chrome. Our team is continuously working to improve the functions in all browsers and apologize for any inconvenience.',
    {
      nameSpace: 'ssr-resource',
    }
  )
  // Create Close Button (X)
  const closeButton = document.createElement('button')
  closeButton.classList.add('custom-close-btn')
  closeButton.textContent = 'X'

  // Append elements to form the full consent banner
  bannerInner.appendChild(messageColumn)
  bannerInner.appendChild(closeButton)
  bannerContent.appendChild(bannerInner)
  consentContainer.appendChild(bannerContent)

  // Append the consent banner to the body of the document
  document.body.appendChild(consentContainer)

  // Add event listener to the close button (X)
  closeButton.addEventListener('click', function () {
    document.body.removeChild(consentContainer) // Remove the consent banner when X is clicked
  })

  console.log('Consent Banner Added to the Page')
}

export { customGdprPopup }
